import React from "react";

function LeftArrowIcon() {
  return (
    <svg
      className='leftArrowIcon'
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="22"
      fill="none"
      viewBox="0 0 22 22"
    >
      <path
        stroke="#9197B3"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M12.833 5.5l-5.5 5.5 5.5 5.5"
      ></path>
    </svg>
  );
}

export default LeftArrowIcon;